export const STORAGE_TOKEN = '@essemie/token';
export const STORAGE_REFRESH_TOKEN = '@essemie/refreshToken';
export const USERNAME = '@essemie/username';
